import {SEARCH_FILTERS_AND_SORT_TEST_ID} from "@pg-mono/test-ids";

// Id obszaru filtra wg filterSlot.id. Obsługuje wszystkie widoki filtrów: listing (drawer i modal mobile), stronę inwestycji, modal oferty i panel oferty na mapie.
// W części widoków na mobile w DOM jest też ukryta kopia obszaru, więc test musi brać widoczny element (.filter({visible: true})).
// Nowy slot filtra dodajemy tu i w SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA; test obok pilnuje, żeby żaden nie został pominięty.
const FILTER_AREA_TEST_ID_BY_SLOT_ID: Partial<Record<string, string>> = {
    type: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.PROPERTY_TYPE,
    price: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.BUDGET,
    rooms: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.ROOMS,
    area: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.SURFACE,
    floor_choices: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.FLAT_FLOORS,
    construction_end_date: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.DELIVERY_DATE,
    house_type: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_TYPE,
    house_storeys: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_FLOORS,
    house_additional_areas: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_EXTRAS
};

export const getFilterAreaTestId = (slotId: string): string | undefined => FILTER_AREA_TEST_ID_BY_SLOT_ID[slotId];
import {SEARCH_FILTERS_AND_SORT_TEST_ID} from "@pg-mono/test-ids";

// Id obszaru filtra wg filterSlot.id. Obsługuje wszystkie widoki filtrów: listing (drawer i modal mobile), stronę inwestycji, modal oferty i panel oferty na mapie.
// W części widoków na mobile w DOM jest też ukryta kopia obszaru, więc test musi brać widoczny element (.filter({visible: true})).
// Nowy slot filtra dodajemy tu i w SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA; test obok pilnuje, żeby żaden nie został pominięty.
const FILTER_AREA_TEST_ID_BY_SLOT_ID: Partial<Record<string, string>> = {
    type: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.PROPERTY_TYPE,
    price: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.BUDGET,
    rooms: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.ROOMS,
    area: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.SURFACE,
    floor_choices: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.FLAT_FLOORS,
    construction_end_date: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.DELIVERY_DATE,
    house_type: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_TYPE,
    house_storeys: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_FLOORS,
    house_additional_areas: SEARCH_FILTERS_AND_SORT_TEST_ID.FILTER_AREA.HOUSE_EXTRAS
};

export const getFilterAreaTestId = (slotId: string): string | undefined => FILTER_AREA_TEST_ID_BY_SLOT_ID[slotId];
